import React, { useEffect, useState } from 'react';

const TypingText = ({ texts, speed = 100, loop = false, onChange }) => {
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    const [displayText, setDisplayText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        let timeoutId;

        const currentText = texts[currentTextIndex];

        if (!isDeleting) {
            // Typing mode: add words one by one
            if (displayText.length < currentText.length) {
                timeoutId = setTimeout(() => {
                    setDisplayText(currentText.substring(0, displayText.length + 1));
                }, speed);
            } else {
                // Switch to deleting mode after a delay
                timeoutId = setTimeout(() => setIsDeleting(true), 500); // Delay before deleting
            }
        } else {
            // Deleting mode: remove words one by one
            if (displayText.length > 0) {
                timeoutId = setTimeout(() => {
                    setDisplayText(displayText.substring(0, displayText.length - 1));
                }, speed);
            } else {
                // Move to the next text after deleting is complete
                setIsDeleting(false);
                setCurrentTextIndex((prevIndex) => {
                    const nextIndex = prevIndex + 1;
                    if (nextIndex >= texts.length) {
                        return loop ? 0 : prevIndex; // Restart from the beginning if loop is true
                    }
                    return nextIndex;
                });
            }
        }

        // Call the onChange callback to update the parent component
        onChange(displayText);

        // Cleanup on unmount or when dependencies change
        return () => clearTimeout(timeoutId);
    }, [texts, speed, loop, currentTextIndex, displayText, isDeleting, onChange]);

    return null; // This component doesn't render anything
};

export default TypingText;